import { format, parseISO } from 'date-fns';
import { Scan } from '../../../../../services/entities/impl/blfApi/schemas/scan';

/**
 * Formats a scan's display name based on available information.
 *
 * The formatted name will include the scan date (if available) in MM/DD format,
 * followed by customer short code and block name if they exist.
 * These components are separated by " / " in the final string.
 *
 * If scan date processing fails, the function will log an error and fall back
 * to using the scan's name property (or empty string if name doesn't exist).
 *
 * @param scan - The scan object containing information to be formatted
 * @returns A formatted string representation of the scan
 */
export const formatScanName = (scan: Scan): string => {
  let displayName = scan.name || '';
  if (scan.scanDate) {
    try {
      const formattedDate = format(parseISO(scan.scanDate), 'M/dd');
      const parts = [formattedDate];

      if (scan.customerShortCode) {
        parts.push(scan.customerShortCode);
      }

      if (scan.blockName) {
        parts.push(scan.blockName);
      }

      displayName = parts.join(' / ');
    } catch (e) {
      console.error('Error formatting scan date', e);
    }
  }
  return displayName;
};
